import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/_components/custom-header/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/field-wrapper/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NewAppealButton"] */ "/app/src/app/[locale]/_components/appeal-auth/_components/new-appeal-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/_components/appeal-auth/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FormTabs"] */ "/app/src/app/[locale]/_components/new-appeal/_components/form-tabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/_components/new-appeal/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/index.module.scss");
